import React from 'react';

export const LocationSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 14.972C0 6.6922 6.91899 0 15.2882 0C23.681 0 30.6 6.6922 30.6 14.972C30.6 19.1442 29.0826 23.0177 26.5851 26.3008C23.8298 29.9223 20.4339 33.0776 16.6114 35.5544C15.7365 36.1267 14.947 36.1699 13.9868 35.5544C10.1425 33.0776 6.74656 29.9223 4.0149 26.3008C1.51557 23.0177 0 19.1442 0 14.972ZM10.2498 15.4391C10.2498 18.2128 12.5132 20.3943 15.2884 20.3943C18.0654 20.3943 20.3506 18.2128 20.3506 15.4391C20.3506 12.687 18.0654 10.3992 15.2884 10.3992C12.5132 10.3992 10.2498 12.687 10.2498 15.4391Z" fill={color} />
      </svg>

    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 31 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 14.972C0 6.6922 6.91899 0 15.2882 0C23.681 0 30.6 6.6922 30.6 14.972C30.6 19.1442 29.0826 23.0177 26.5851 26.3008C23.8298 29.9223 20.4339 33.0776 16.6114 35.5544C15.7365 36.1267 14.947 36.1699 13.9868 35.5544C10.1425 33.0776 6.74656 29.9223 4.0149 26.3008C1.51557 23.0177 0 19.1442 0 14.972ZM10.2498 15.4391C10.2498 18.2128 12.5132 20.3943 15.2884 20.3943C18.0654 20.3943 20.3506 18.2128 20.3506 15.4391C20.3506 12.687 18.0654 10.3992 15.2884 10.3992C12.5132 10.3992 10.2498 12.687 10.2498 15.4391Z" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
    </svg>
  )
}